import script from "./TempP.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempP.vue?vue&type=script&lang=ts&setup=true"

import "./TempP.vue?vue&type=style&index=0&id=0e61d782&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e61d782"]])

export default __exports__